module.exports = __webpack_public_path__ + "js/0.627de98a.worker.js"